module.exports = function(it){
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


//////////////////
// WEBPACK FOOTER
// /home/backend/NasheDelo/WebLombard/client/~/jszip/~/core-js/library/modules/_is-object.js
// module id = ../../../../jszip/node_modules/core-js/library/modules/_is-object.js
// module chunks = 3